<template>
  <div>
    <h5 class="mt-1">{{ t("SETAMOUNTTOPAY") }}</h5>
    <h1 class="text-center display-1 text-break" id="amount-field">
      {{ currencyFormat(paying) }}
    </h1>
    <Keyboard @onChange="onChange" ref="kbRef" />
    <button class="withdraw-amount-btn" @click="switchStep('chooseMethod')">
      {{ t("CONFIRM") }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import Keyboard from "@/apps/credit-line/components/Keyboard.vue";

const { t } = useI18n();
const switchStep = inject("switchStep");
const onChange = inject("onChange");
const currencyFormat = inject("currencyFormat");
const paying = inject("paying");
const kbRef = inject("kbRef");
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.withdraw-amount-btn {
  border: none;
  height: 40px;
  background-color: $pj-color-green;
  color: $pj-color-white;
  width: 100%;
  border-bottom-left-radius: 10px;
  font-weight: bold;
  border-bottom-right-radius: 10px;
}

/*
  Theme: numeric
*/
.numeric-theme {
  max-width: 100%;
  margin: 0 auto;
}

.numeric-theme + .simple-keyboard-preview {
  max-width: 100%;
}

.simple-keyboard.hg-theme-default.numeric-theme.hg-button.hg-standardBtn.hg-button-at {
  max-width: none;
}

#amount-field {
  font-size: 1.5rem !important;
}
</style>
